import React from "react";
import { ITEM_TYPE } from "../../Enums/Enum";
import TwoItemSummaryFooter from "../shared/TwoItemSummaryFooter";

/**
 * Footer for the Additions/Deductions table showing totals.
 */
const AddDedTableFooter = React.memo(function AddDedTableFooter({ addAndDeductions, formatCurrency }) {
    const totalAdditions = (addAndDeductions || []).reduce(
        (sum, r) => sum + (Number(r.addDeduction) === Number(ITEM_TYPE.Additions) ? Number(r.amount || 0) : 0), 0
    );
    const totalDeductions = (addAndDeductions || []).reduce(
        (sum, r) => sum + (Number(r.addDeduction) === Number(ITEM_TYPE.Deductions) ? Number(r.amount || 0) : 0), 0
    );

    return (
        <TwoItemSummaryFooter
            items={[
                { label: "Total Additions", value: formatCurrency(totalAdditions) },
                { label: "Total Deductions", value: formatCurrency(totalDeductions) }
            ]}
        />
    );
});

export default AddDedTableFooter;
